import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { HdsAppFooter } from '@hashicorp/design-system-components/components';
import { Typography } from 'core/components';
import { classNames } from 'core/helpers';
import { boxMargin } from 'core/modifiers';

import HcpLogo from 'hcp/components/hcp-marketing/hcp-logo';

/**
 *
 * `ApplicationLoading` renders the initial loading screen before the app is loaded.
 *
 *
 * ```
 * <ApplicationLoading />
 * ```
 *
 * @class ApplicationLoading
 *
 */

export default class ApplicationLoading extends Component {
  @service session;
  @service systemStatus;

  get statusPageUrl() {
    return this.systemStatus.statusPageUrl;
  }
  <template>
    <section class="applicationLoading" data-application-loading-section>
      <header
        class="applicationLoading__header"
        data-application-loading-header
      >
        <div>
          <HcpLogo data-application-loading-logo />
          <Typography data-application-loading-message>
            {{t "components.loading.message"}}
          </Typography>
          <div
            class={{classNames
              "longerLoadTime"
              (if this.session.isSilentAuthTooLong "longerLoadTime--visible")
            }}
            data-application-loading-longer-message
          >
            <hr {{boxMargin "xl 0 xl 0"}} />
            <Typography>
              {{t "components.loading.longer-load-message"}}
            </Typography>
          </div>
        </div>
      </header>
      <HdsAppFooter @theme="dark" data-application-loading-footer as |AF|>
        <AF.StatusLink
          @text={{t "components.hcp.status-page-link"}}
          href={{this.statusPageUrl}}
        />
        <AF.Link @href="https://cloud.hashicorp.com/docs/changelog">{{t
            "components.layout.footer.changelog"
          }}</AF.Link>
        <AF.LegalLinks />
      </HdsAppFooter>
    </section>
  </template>
}
